var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 6C16.7438 6 6 16.7438 6 30C6 43.2562 16.7438 54 30 54C43.2562 54 54 43.2562 54 30C54 16.7438 43.2562 6 30 6ZM44.9812 44.9719C43.0312 46.9219 40.7719 48.45 38.25 49.5094C35.6437 50.6156 32.8687 51.1687 30 51.1687C27.1406 51.1687 24.3656 50.6062 21.75 49.5094C19.2281 48.4406 16.9594 46.9125 15.0187 44.9719C13.0687 43.0219 11.5406 40.7625 10.4813 38.2406C9.375 35.6344 8.8125 32.8594 8.8125 30C8.8125 27.1406 9.375 24.3656 10.4719 21.75C11.5406 19.2281 13.0687 16.9594 15.0094 15.0187C16.9688 13.0687 19.2281 11.5406 21.75 10.4719C24.3656 9.375 27.1406 8.8125 30 8.8125C32.8594 8.8125 35.6344 9.375 38.25 10.4719C40.7719 11.5406 43.0406 13.0688 44.9812 15.0094C46.9312 16.9594 48.4594 19.2187 49.5188 21.7406C50.625 24.3469 51.1781 27.1219 51.1781 29.9906C51.1781 32.85 50.6156 35.625 49.5188 38.2406C48.45 40.7625 46.9219 43.0312 44.9812 44.9719Z",
    fill: "#0885C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2875 25.0688H18.6094V40.0406H23.2875V25.0688Z",
    fill: "#0885C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 18C19.1251 18 17.9907 19.1156 17.9907 20.5969C17.9907 22.05 19.0876 23.1937 20.7845 23.1937H20.822C22.5845 23.1937 23.6813 22.0406 23.672 20.5969C23.6345 19.1156 22.5751 18 20.8501 18Z",
    fill: "#0885C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0656 24.9281C33.3843 24.9281 31.7062 26.3906 31.3968 27.4219V25.0688H26.1375C26.2031 26.3156 26.1375 40.0406 26.1375 40.0406H31.3968V31.95C31.3968 31.4906 31.3781 31.0406 31.5093 30.7219C31.8656 29.8219 32.6437 28.8844 34.0406 28.8844C35.8687 28.8844 36.6937 30.2719 36.6937 32.2969V40.0406H42V31.7156C42 27.0844 39.3937 24.9281 36.0656 24.9281Z",
    fill: "#0885C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.c368449b2e61b529fd902fafb1368b74.svg";
export { ForwardRef as ReactComponent };